import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
  AfterViewInit,
  Input,
} from '@angular/core';
import { AgmMap, MapsAPILoader } from '@agm/core';
import { SubjectService } from 'src/app/services/subject.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { MouseEvent } from '@agm/core/services/google-maps-types';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { CartService } from 'src/app/services/cart.service';
import { ModalController } from '@ionic/angular';
import { ShippingAddressFormComponent } from '../shipping-address-form/shipping-address-form.component';
import { AddShippingComponent } from 'src/app/checkout/add-shipping/add-shipping.component';
import { AppiceService } from 'src/app/services/appice.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
declare var google: any;

@Component({
  selector: 'app-map-locator',
  templateUrl: './map-locator.component.html',
  styleUrls: ['./map-locator.component.scss'],
})
export class MapLocatorComponent implements OnInit, AfterViewInit {
  @Input() shippingAddress: any;
  @Input() isQuestionAnswered: boolean;
  @Output() onAnswerSelection = new EventEmitter<any>();
  @Output() onCurrentSelectedAnswer = new EventEmitter<any>();
  @ViewChild('myInput', { static: true }) myInput: ElementRef;
  @Input() selectedLocation :any;
  shoppingCart: any;

  // @ViewChild(AgmMap) public agmMap: AgmMap;
  cart: any;
  currentSelectedAnswerCloned: HelpMeDecideAnswer;
  LocationCtrl: any;
  isVisible: boolean = false;
  geocoder: any;
  showClear: boolean = false;
  loader: boolean = false;
  markerVisible: boolean = true;

  options = {
    componentRestrictions: { country: 'ae' },
  };
  googleMapType = 'hybrid';
  // showButtonLoader = false;
  public location: Location = {
    lat: 25.204849,
    lng: 55.270783,
    marker: {
      lat: 25.204849,
      lng: 55.270783,
      draggable: false,
    },
    zoom: 15,
    address: '',
  };
  @ViewChild('AgmMap', { static: true }) map: AgmMap;
  emirate: string;
  city: any;
  constructor(
    private SS: SubjectService,
    private GAS: GoogleAnalyticsService,
    private CS: CartService,
    private ngZone: NgZone,
    private modalController: ModalController,
    private appice: AppiceService,
    private UTS: UtilitiesService,
    private AAS: AdobeAnalyticsService,
  ) { }
  address: string = '';

  ngOnInit() {
    this.onInitProcess();
    this.getShoppingCart();
  }

  onInitProcess() {
    if (this.shippingAddress) {
      this.markerVisible = true;
      this.location.lat = Number(this.shippingAddress.latitude);
      this.location.lng = Number(this.shippingAddress.longitude);
      this.location.marker.lat = Number(this.shippingAddress.latitude);
      this.location.marker.lng = Number(this.shippingAddress.longitude);
      this.location.address = this.shippingAddress.area || '';
      this.location.zoom = 15;
    }else if(!this.shippingAddress && this.selectedLocation){
      this.markerVisible = true;
      this.location.lat = Number(this.selectedLocation.lat);
      this.location.lng = Number(this.selectedLocation.lng);
      this.location.marker.lat = Number(this.selectedLocation.lat);
      this.location.marker.lng = Number(this.selectedLocation.lng);
      this.location.address = this.selectedLocation.address || '';
      this.location.zoom = 15;
    } else {
      this.setCurrentLocation(true);
    }
    this.geocoder = new google.maps.Geocoder();
    this.location.marker.draggable = true;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.map.triggerResize();
    }, 100);
  }
  onInputChange = (input: string) => {
    this.address = input;

    setTimeout(() => {
      this.myInput.nativeElement.focus();
    }, 500);
  };

  onKeyPress = (button: string) => {
    this.myInput.nativeElement.focus();
    if (button === '{shift}' || button === '{lock}') this.handleShift();
    if (button === '{bksp}') this.handleBackSpace();
  };

  handleShift = () => { };

  handleBackSpace = () => {
    if (this.address.length == 0) {
      this.myInput.nativeElement.focus();
    } else {
      this.address = this.address.slice(0, -1);
      this.myInput.nativeElement.focus();
    }
  };

  public handleAddressChange(address: Address) {
    // this.showButtonLoader = true;
    let lat = Number(JSON.stringify(address.geometry.location.lat()));
    let lng = Number(JSON.stringify(address.geometry.location.lng()));
    this.markerVisible = true;
    let emirate = address.address_components[0].long_name;
    this.location.address_state = emirate;
    this.location.address = address.formatted_address;
    this.location.lat = lat;
    this.location.lng = lng;
    this.location.marker.lat = lat;
    this.location.marker.lng = lng;
    this.location.zoom = 18;
    this.getAddress(lat, lng);
    this.cart = this.CS.getCart();
    this.GAS.checkoutCTATracking(this.cart?.items,'checkout_cta_click');
    this.optimizeCheckoutTracking('search_location','search text');
    if (address) {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    }
    this.isAvailable();
    this.isVisible = false;
  }
  private setCurrentLocation(visible: boolean = false) {
    const options: any = {
      timeout: 7000,
      enableHighAccuracy: true,
      maximumAge: 0,
    };
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.markerVisible = visible;
          this.location.lat = position.coords.latitude;
          this.location.lng = position.coords.longitude;
          this.location.marker.lat = position.coords.latitude;
          this.location.marker.lng = position.coords.longitude;
          this.location.address = '';
          this.location.zoom = 15;
          this.getAddress(this.location.lat, this.location.lng);
        },
        (e: any) => {
          this.UTS.log(e);
        },
        options
      );
    }
  }
  clearLocationText(): void {
    this.address = '';
    this.isQuestionAnswered = false;
    this.myInput.nativeElement.focus();
  }
  showKeyboard(): void {
    this.showClear = true;
    this.isVisible = true;
  }

  mapClicked($event) {
    // this.showButtonLoader = true;
    this.markerVisible = true;
    let lat = $event.coords.lat;
    let lng = $event.coords.lng;
    this.location.lat = lat;
    this.location.lng = lng;
    this.location.marker.lat = lat;
    this.location.marker.lng = lng;
    this.location.zoom = 18;
    this.isQuestionAnswered = false;
    this.loader = true;
    setTimeout(() => {
      this.loader = false;
    }, 1000);
    this.isAvailable();
    this.getAddress(lat, lng);
  }

  // getAddresses(lat, lng) {
  //   const geocoder = new google.maps.Geocoder();
  //   var latlng = new google.maps.LatLng(lat, lng);
  //   const request: google.maps.GeocoderRequest = {
  //     location: latlng
  //   };
  //   geocoder.geocode(request, (results, status) => {
  //     this.ngZone.run(() => {
  //       const address = results[0].formatted_address;
  //       return address
  //     });
  //   });
  // }

  markerDragEnd(m: Marker, $event: any) {
    // this.showButtonLoader = true;
    let lat = $event.coords.lat;
    let lng = $event.coords.lng;
    this.location.lat = lat;
    this.location.lng = lng;
    this.location.marker.lat = lat;
    this.location.marker.lng = lng;
    this.isQuestionAnswered = false;
    this.isAvailable();
    this.getAddress(lat, lng);
  }

  isAvailable() {
    // this.helpMeDecideService.checkAvailability(this.location).subscribe(res =>{
    // });
  }

  async openModal(sa: any = null) {
    const modal = await this.modalController.create({
      component: AddShippingComponent,
      cssClass: 'ion-modal-uplift eand-partail-height-screen-bottom',
      componentProps: { shippingAddress: sa,cart:this.shoppingCart },
    });
    return await modal.present();
  }

  save() {
    this.optimizeCheckoutTracking('confirm_location','save');
    this.CS.getShoppingCart().subscribe((res: any) => {
      this.GAS.checkoutCTATracking(res?.items,'checkout_cta_click');
      for (let i of res.items) {
        this.appice.passAllProductsToCart('Checkout', 'Confirm_Location', i, i);
      }
    });
    // if (this.shippingAddress) {
    //   this.shippingAddress.latitude = this.location.lat;
    //   this.shippingAddress.longitude = this.location.lng;
    // }
    this.loader = true;
    setTimeout(() => {
      this.modalController.dismiss();
      this.openModal(this.shippingAddress).then((a) => {
        this.SS.nextStep.next(1);
        this.cart = this.CS.getCart();
        this.GAS.confirmLocation_addNewAddress_checkout(this.cart);
        this.AAS.addLinkCTAEvent("Confirm Location","other","Shipping","Select Delivery Location","Confirm Location");
        const response = {...this.location,...{city:this.city},...{emirate:this.emirate}};
        this.SS.mapService.next(response);
        this.loader = false;
      });
    }, 1000);
  }

  dismiss() { }

  // getReverseGeocodingData(lat, lng) {
  //   var latlng = new google.maps.LatLng(lat, lng);
  //   // This is making the Geocode request
  //   var geocoder = new google.maps.Geocoder();
  //   geocoder.geocode({ 'latLng': latlng }, (results, status) => {
  //     if (status !== google.maps.GeocoderStatus.OK) {
  //       alert(status);
  //     }
  //     // This is checking to see if the Geoeode Status is OK before proceeding
  //     if (status == google.maps.GeocoderStatus.OK) {
  //       this.location.address = (results[0].formatted_address);
  //     }
  //   });
  // }


  getAddress(latitude, longitude) {
    this.geocoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if ("United Arab Emirates" != results[results.length - 1].address_components[0].long_name) {
            results.splice(results.length - 1, 1);
          }
          var arrAddress = results;
          this.location.address = this.getFormattedAddress(results);
          this.address = this.getFormattedAddress(results);
          // fix 779216
          var addressComponentForEmirates;
          results[0].address_components.forEach(function (addressComponent) {
            addressComponent.types.forEach(function (type) {
              if (type == "administrative_area_level_1") {
                addressComponentForEmirates = addressComponent;
              }
            });
          });
          // this.emirate = this.getEmirate(addressComponentForEmirates.long_name.toString());
          this.emirate = addressComponentForEmirates.long_name.toString();
          this.city = addressComponentForEmirates.long_name;
        }
        else {
          this.UTS.log('Geocoder failed due to: ' + status);
        }
        /*  if (status === 'OK') {
            if (results[0]) {
              this.location.address = results[0].formatted_address;
              // this.showButtonLoader = false;
            } else {
              // window.alert('No results found');
            }
          } else {
            // window.alert('Geocoder failed due to: ' + status);
          }*/
      }
    );
  }

  getCurrentLocation() {
    this.optimizeCheckoutTracking('confirm_location','audio');
    this.setCurrentLocation(true);
  }


  toUnicode(theString) {
    var unicodeString = '';
    for (var i = 0; i < theString.length; i++) {
      var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
      while (theUnicode.length < 4) {
        theUnicode = '0' + theUnicode;
      }
      theUnicode = '\\u' + theUnicode;
      unicodeString += theUnicode;
    }
    return unicodeString;
  }

  getEmirate(address_components) {
    var emirate = "";
    var emirateUnicode = this.toUnicode(address_components);
    if (
      (
        emirateUnicode.indexOf("\\u0044\\u0075\\u0062\\u0061\\u0069") != -1 ||
        emirateUnicode.indexOf("\\u062F\\u0628\\u064A") != -1)
      || (
        emirateUnicode.indexOf('\u0044\u0075\u0062\u0061\u0069') != -1 ||
        emirateUnicode.indexOf('\u062F\u0628\u064A') != -1)) {
      emirate = "DXB";
    } else if (
      (
        emirateUnicode.indexOf("\\u0044\\u0068\\u0061\\u0062\\u0069") != -1 ||
        emirateUnicode.indexOf("\\u0638\\u0628\\u064A") != -1) ||
      (
        emirateUnicode.indexOf("\u0044\u0068\u0061\u0062\u0069") != -1 ||
        emirateUnicode.indexOf("\u0638\u0628\u064A") != -1)) {
      emirate = "AUH";
    } else if (
      (
        emirateUnicode.indexOf("\\u0053\\u0068\\u0061\\u0072\\u006A\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0634\\u0627\\u0631\\u0642\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u0053\u0068\u0061\u0072\u006A\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0634\u0627\u0631\u0642\u0629") != -1)) {
      emirate = "SHJ";
    } else if (
      (
        emirateUnicode.indexOf("\\u0041\\u006A\\u006D\\u0061\\u006E") != -1 ||
        emirateUnicode.indexOf("\\u0639\\u062C\\u0645\\u0627\\u0646") != -1) ||
      (
        emirateUnicode.indexOf("\u0041\u006A\u006D\u0061\u006E") != -1 ||
        emirateUnicode.indexOf("\u0639\u062C\u0645\u0627\u0646") != -1
      )
    ) {
      emirate = "AJM";
    } else if (
      (
        emirateUnicode.indexOf("\\u004B\\u0068\\u0061\\u0069\\u006D\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0627\\u0644\\u062E\\u064A\\u0645\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u004B\u0068\u0061\u0069\u006D\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0627\u0644\u062E\u064A\u0645\u0629") != -1
      )
    ) {
      emirate = "RAK";
    } else if (
      (
        emirateUnicode.indexOf("\\u0051\\u0075\\u0077\\u0061\\u0069\\u006e") != -1 ||
        emirateUnicode.indexOf("\\u0642\\u064A\\u0648\\u064A\\u0646") != -1) ||
      (
        emirateUnicode.indexOf("\u0051\u0075\u0077\u0061\u0069\u006e") != -1 ||
        emirateUnicode.indexOf("\u0642\u064A\u0648\u064A\u0646") != -1
      )
    ) {
      emirate = "UAQ";
    } else if (
      (
        emirateUnicode.indexOf("\\u0046\\u0075\\u006A\\u0061\\u0069\\u0072\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0641\\u062C\\u064A\\u0631\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u0046\u0075\u006A\u0061\u0069\u0072\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0641\u062C\u064A\u0631\u0629") != -1
      )
    ) {
      emirate = "FUJ";
    }
    return emirate;

  }

  getFormattedAddress(locationSuggestions){
    let formatted_address = '';
      locationSuggestions[0].address_components.every(map=>{if(map.types.indexOf('premise')!=-1 || map.types.indexOf('neighborhood')!=-1){
        formatted_address=formatted_address+map.long_name+' - ';
        return false;
        }
        return true;
      })
      locationSuggestions[0].address_components.every(map=>{if(map.types.indexOf('street_number')!=-1){
        formatted_address=formatted_address+map.long_name+' - ';
        return false;
        }
        return true;
      })
      locationSuggestions[0].address_components.every(map=>{if(map.types.indexOf('route')!=-1){
        formatted_address=formatted_address+map.long_name+' - ';
        return false;
        }
        return true;
      })
      locationSuggestions[0].address_components.every(map=>{if(map.types.indexOf('administrative_area_level_1')!=-1){
        formatted_address=formatted_address+map.long_name+' - ';
        return false;
        }
        return true;
      })
      locationSuggestions[0].address_components.every(map=>{if(map.types.indexOf('administrative_area_level_2')!=-1 || map.types.indexOf('country')!=-1){
        formatted_address=formatted_address+map.long_name;
        return false;
        }
        return true;
      })
    return formatted_address;
  }
  optimizeCheckoutTracking(event, info) {
    if (this.shoppingCart?.items?.length > 0) {
      this.GAS.checkoutOptimizationTracking(event, this.shoppingCart?.items, this.shoppingCart, '', info, 'checkout');
    }
  }
  getShoppingCart() {
    this.CS.getShoppingCart().subscribe((res: any) => {
      if (res && res?.items) {
        this.shoppingCart = res;
      }
    });
  }

}

interface Location {
  lat: number;
  lng: number;
  viewport?: Object;
  zoom: number;
  address_country?: string;
  address_zip?: string;
  address_state?: string;
  marker?: Marker;
  address: string;
}

interface Marker {
  lat: number;
  lng: number;
  label?: string;
  draggable?: boolean;
  clickable?: boolean;
  animation?: number;
  icon?: string;
  position?: any;
}

export class HelpMeDecideAnswer {
  'answerId': string;
  'answerText1English': string;
  'answerText1Arabic': string;
  'answerText2English': string;
  'answerText2Arabic': string;
  'answerText3English': string;
  'answerText3Arabic': string;
  'answerImageURL': string;
  'isHidden': boolean = false;
}
